<h6 class="border-bottom border-gray pb-2 mb-0">Recent logs</h6>

<ng-container *ngFor="let log of lastLogs">
  <div class="media pt-2">
    <div class="media-body pb-2 mb-0 small lh-125 border-bottom border-gray">
      <div class="d-flex justify-content-between align-items-center w-100 pb-1">
        <strong class="text-gray-dark"><em [innerHTML]="getUsernameElement(log)"></em></strong>
        <span class="text-muted">{{log.created}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center w-100">
        <span><span class="me-1" [innerHTML]="getLogLabel(log)"></span>{{log.message}}</span>
        <a [routerLink]="getLogDetailLink(log)">View</a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="lastLogs === undefined">
  <app-spinner></app-spinner>
</ng-container>

<div class="d-block text-end mt-3">
  <small><a routerLink="/admin/logs">View all logs</a></small>
</div>
